import { render, staticRenderFns } from "./CustomerTable.vue?vue&type=template&id=99039d72&"
import script from "./CustomerTable.vue?vue&type=script&lang=js&"
export * from "./CustomerTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/musili/musilidev/webroot/work-bmm/01_DEX/dex/front-end/web-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99039d72')) {
      api.createRecord('99039d72', component.options)
    } else {
      api.reload('99039d72', component.options)
    }
    module.hot.accept("./CustomerTable.vue?vue&type=template&id=99039d72&", function () {
      api.rerender('99039d72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenant/views/Dashboard/Components/CustomerTable.vue"
export default component.exports